import type { ThemeButton, ThemeButtonPreset } from '@sites/site-theme/src/types/theme-button.type';

import { hashCode } from '@common/helpers/hash';

import { DEFAULT_BUTTON_PRESETS } from '@sites/site-theme/src/config/presets';

export function getThemeButtonPresets(): ThemeButtonPreset[] {
    return DEFAULT_BUTTON_PRESETS.map((buttons: ThemeButton[]) => ({
        index: hashCode(buttons),
        // Spread rather than `filterEmptyFields`: that helper lives in `@common/helpers/forms`,
        // which imports `@angular/forms`, and it did nothing here beyond dropping the two keys when
        // a preset happens to lack them. `index` is hashed from `buttons`, not from this, so
        // spelling the omission out changes no preset's id.
        values: buttons.map((button: ThemeButton) => ({
            styleType: button.styleType,
            ...(button.base ? { base: button.base } : {}),
            ...(button.hover ? { hover: button.hover } : {}),
        })),
    }));
}
